import {
  ActionIcon,
  Button,
  Card,
  Center,
  createStyles,
  Drawer,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  Select,
  SimpleGrid,
  Table,
  Tabs,
  Text,
  TextInput,
  UnstyledButton,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { IconChevronDown, IconChevronUp, IconSelector } from "@tabler/icons";
import axios from "axios";
import ActionButton from "components/controls/ActionButtonNew";
import { DriverAddModal } from "components/Driver/DriverAddModal";
import DriverDetailModal from "components/Driver/DriverDetail";
import { DriverEditModal } from "components/Driver/DriverEditModal";
import { customLoader } from "components/utilities/loader";
import VehicleAddModal from "components/Vehicle/VehicleAddModal";
import Pusher from "pusher-js";
import { Fragment, useEffect, useState } from "react";
import { FiEye } from "react-icons/fi";
import { Plus, Search, X } from "tabler-icons-react"; // Import a close icon
import ExportComponent from "utiles/export";
import { API, formatNumber, PAGE_SIZE_OPTIONS } from "utiles/url";
import Demo from "./activeDrivers";
import MapView from "./mapView";
import MinmumBalance from "./minumunBalance";
import NewDriver from "./newDriver";

const useStyles = createStyles((theme) => ({
  th: {
    padding: "0 !important",
  },

  control: {
    width: "100%",
    padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,

    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
    },
  },

  icon: {
    width: 21,
    height: 21,
    borderRadius: 21,
  },
  thh: {
    color: "#666666",
    fontFamily: "'__Inter_aaf875','__Inter_Fallback_aaf875'",
    fontSize: "10px",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  idColumn: {
    width: "3%",
  },
  cityColumn: {
    width: "4%",
  },

  searchContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  searchInput: {
    flexGrow: 1,
    paddingRight: "50px", // Add padding to avoid text overlap with button
  },
  searchButton: {
    position: "absolute",
    right: 0,
    borderRadius: "0 4px 4px 0",
    height: "70%",
    width: "40px", // Fixed width for the button
    backgroundColor: "#FF6A00",
    color: "#FFFFFF",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "14px",
    cursor: "pointer",
  },
}));

function Th({ children, sortable, sorted, reversed, onSort }) {
  const { classes } = useStyles();
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;

  return (
    <th className={classes.th}>
      <UnstyledButton
        onClick={sortable ? onSort : null}
        className={classes.control}
      >
        <Group position="apart">
          <Text weight={500} size="sm">
            {children}
          </Text>
          {sortable && (
            <Center className={classes.icon}>
              <Icon size={14} stroke={1.5} />
            </Center>
          )}
        </Group>
      </UnstyledButton>
    </th>
  );
}

const Drivers = () => {
  const { classes } = useStyles();
  const [size, setSize] = useState("10");
  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
    fetchData(newSize, 1);
  };
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [activeTab, setActiveTab] = useState("first");

  const [openedEdit, setOpenedEdit] = useState(false);
  const [editId, setEditId] = useState();
  const [editRow, setEditRow] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [search, setSearch] = useState("");
  const [sortedData, setSortedData] = useState([]);
  const [activeDrivers, setActiveDrivers] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [openedVehicle, setOpenedVehicle] = useState(false);
  const [driver_id, setDriverId] = useState(null);

  useEffect(() => {
    const pusher = new Pusher("83f49852817c6b52294f", {
      cluster: "mt1",
    });
    const notificationChannel = pusher.subscribe("driver-location");
    notificationChannel.bind("driver-location", function (data) {
      console.log("Pusher event received:", data);
      setActiveDrivers(data.data);
    });
    return () => {
      // Unsubscribe from channels, disconnect, etc.
      pusher.disconnect();
    };
  }, []);

  useEffect(() => {
    fetchData(size, activePage);
  }, [size, activePage]);

  const fetchData = async (size, page) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get(
        `${API}/drivers?page=${page}&first=${size}`,
        config,
      );
      if (response.data) {
        setLoading(false);
        setDrivers(response.data.data);
        setSortedData(response.data.data); // Ensure sorting is applied when data is fetched
        setTotalPages(response.data.paginatorInfo.last_page);
        setTotalRecords(response.data.meta.total);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  const handleSearchChange = async () => {
    setLoading(true);
    try {
      let token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get(
        `${API}/drivers?search=${search}&page=${activePage}&first=${size}`,
        config,
      );
      if (response.data) {
        setDrivers(response.data.data);
        setSortedData(response.data.data);
        setTotal(response.data?.links);
        setTotalPages(response.data.paginatorInfo.last_page);
        setTotalRecords(response.data.meta.total);

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const sortData = (data, payload) => {
    if (!payload.sortBy) {
      return filterData(data, payload.search);
    }

    return filterData(
      [...data].sort((a, b) => {
        if (payload.reversed) {
          return b[payload.sortBy].localeCompare(a[payload.sortBy]);
        }

        return a[payload.sortBy].localeCompare(b[payload.sortBy]);
      }),
      payload.search,
    );
  };

  const handleChange = (page) => {
    setActivePage(page);
    fetchData(size, page);
  };

  const handleSort = (field) => {
    const reversed = field === sortBy ? !reverseSortDirection : false;
    setReverseSortDirection(reversed);
    setSortBy(field);
    setSortedData(sortData(drivers, { sortBy: field, reversed, search }));
  };
  const handleEditDriver = (row) => {
    setOpenedEdit(true);
    console.log(row);
    setEditRow(row);
  };
  const handleManageDriver = (id) => {
    setEditId(id);
    setOpenedDetail(true);
  };

  const filterData = (data, search) => {
    const query = search.toLowerCase().trim();
    return data.filter((item) =>
      Object.keys(item).some(
        (key) =>
          typeof item[key] === "string" &&
          item[key] &&
          item[key].toLowerCase().includes(query),
      ),
    );
  };
  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const deleteDriver = async () => {
    try {
      let token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.delete(`${API}/drivers/${deleteID}`, config);
      if (response.data) {
        fetchData(size, activePage);
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Driver Deleted Successfully",
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setOpenedDelete(false);
      setDeleteID(null);
      showNotification({
        color: "red",
        title: "Error",
        message: `Driver Not Deleted Successfully`,
      });
    }
  };
  const handleTabChange = async (tab) => {
    console.log(tab);
    setActiveTab(tab);
    if (tab === "second") {
      let token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      await axios.get(`${API}/location`, config);
    }
  };
  const theme = useMantineTheme();
  const rows = sortedData?.map((row, rowIndex) => {
    const rowStyle =
      row.wallet?.balance < 1000 ? { backgroundColor: "#FFCCCB" } : {}; // Warning color for balance < 1000

    const idx = (activePage - 1) * parseInt(size || "0") + (rowIndex + 1);

    return (
      <Fragment key={row.id}>
        <tr style={rowStyle}>
          {" "}
          {/* Apply conditional styling to the entire row */}
          <td>{idx}</td>
          <td>{row.user?.name}</td>
          <td>{row.user?.email}</td>
          <td>{row.user?.phone}</td>
          <td className={classes.cityColumn}>{row.region?.name}</td>
          <td>{row.city}</td>
          <td style={{ width: "10%" }}>{row.vehicle?.vehicle_type?.title}</td>
          <td>
            {row.user?.wallet?.balance > 0
              ? formatNumber(row.user.wallet?.balance)
              : "No Balance"}
          </td>
          <td>
            <div style={{ display: "flex", gap: "6px" }}>
              <ActionButton label="Edit" onClick={() => handleEditDriver(row)}>
                <EditIcon style={{ fontSize: "1rem" }} />
              </ActionButton>
              <ActionButton
                label="View"
                color="success"
                onClick={() => handleManageDriver(`${row.id}`)}
              >
                <FiEye fontSize="medium" />
              </ActionButton>
              {/*    
              <ActionButton
                label="Complete"
                color="activate"
                onClick={() => {
                  setOpenedVehicle(true);
                  setDriverId(row.id);
                }}
              >
                <HowToRegIcon style={{ fontSize: 17 }} />
              </ActionButton>

              
<Controls.ActionButton
  color="primary"
  title="Delete"
  onClick={() => handleDelete(`${row.id}`)}
>
  <Trash size={17} />
</Controls.ActionButton>
*/}
            </div>
          </td>
        </tr>
      </Fragment>
    );
  });
  const headerData = [
    { label: "Name", render: (row) => row.user?.name || "N/A" },
    {
      label: "Vehicle Type",
      render: (row) => row.vehicle?.vehicle_type?.title || "N/A",
    },
    { label: "Model", render: (row) => row.vehicle?.model || "N/A" },
    { label: "City", key: "city" },
    { label: "Region", render: (row) => row.region?.name || "N/A" },
  ];
  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <Tabs
      color="#FF6A00"
      value={activeTab}
      styles={{
        tabList: {
          borderBottom: `2px solid #FF6A00`,
        },
        tab: {
          "&[data-active]": {
            borderColor: "#FF6A00",
          },
          "&:hover": {
            borderColor: "#FF6A00",
          },
        },
      }}
      onTabChange={handleTabChange}
    >
      <Tabs.List>
        <Tabs.Tab value="first">
          <span style={{ color: "#666666", fontWeight: "bold" }}>
            All Drivers
          </span>
        </Tabs.Tab>

        <Tabs.Tab value="third">
          <span style={{ color: "#666666", fontWeight: "bold" }}>
            Minmum Balance
          </span>
        </Tabs.Tab>
        <Tabs.Tab value="four">
          <span style={{ color: "#666666", fontWeight: "bold" }}>
            New Driver
          </span>
        </Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="third">
        <MinmumBalance />
      </Tabs.Panel>
      <Tabs.Panel value="four">
        <NewDriver />
      </Tabs.Panel>
      <Tabs.Panel value="second">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            p: 1,
            m: 1,
            bgcolor: "background.paper",
            borderRadius: 1,
          }}
        >
          <div style={{ width: "96%" }}>
            {activeDrivers.length > 0}
            <Card shadow="sm" p="lg">
              <MapView activeDrivers={activeDrivers} />
            </Card>
          </div>
          <div style={{ marginTop: "10px" }}>
            <Card shadow="sm" p="lg">
              <Demo activeDrivers={activeDrivers} />
            </Card>
          </div>
        </Box>
      </Tabs.Panel>
      <Tabs.Panel value="first">
        <div style={{ width: "98%", margin: "auto" }}>
          <Drawer
            opened={openedEdit}
            overlayColor={
              theme.colorScheme === "dark"
                ? theme.colors.dark[9]
                : theme.colors.gray[2]
            }
            overlayOpacity={0.55}
            overlayBlur={3}
            title="Editing a Driver"
            padding="xl"
            onClose={() => setOpenedEdit(false)}
            position="bottom"
            size="80%"
          >
            <DriverEditModal
              activePage={activePage}
              fetchData={fetchData}
              editRow={editRow}
              setOpenedEdit={setOpenedEdit}
              editId={editId}
              size={size}
            />
          </Drawer>
          <Drawer
            opened={opened}
            onClose={() => setOpened(false)}
            title="Adding a Driver"
            padding="xl"
            size="80%"
            position="bottom"
          >
            <DriverAddModal
              total={total}
              size={size}
              activePage={activePage}
              setActivePage={setActivePage}
              setOpened={setOpened}
              fetchData={fetchData}
            />
          </Drawer>
          <Drawer
            opened={openedDetail}
            overlayColor={
              theme.colorScheme === "dark"
                ? theme.colors.dark[9]
                : theme.colors.gray[2]
            }
            overlayOpacity={0.55}
            overlayBlur={3}
            title="Driver Detail"
            padding="xl"
            onClose={() => setOpenedDetail(false)}
            position="bottom"
            size="80%"
          >
            <DriverDetailModal
              total={total}
              setTotal={setTotal}
              activePage={activePage}
              setActivePage={setActivePage}
              setOpenedDetail={setOpenedDetail}
              Id={editId}
            />
          </Drawer>
          <Drawer
            opened={openedVehicle}
            onClose={() => setOpenedVehicle(false)}
            title="Adding a Vehicle"
            padding="xl"
            size="80%"
            position="bottom"
          >
            <VehicleAddModal
              total={total}
              setTotal={setTotal}
              activePage={activePage}
              setActivePage={setActivePage}
              setOpened={setOpenedVehicle}
              driver_id={driver_id}
            />
          </Drawer>
          <Card shadow="sm" p="lg">
            <ScrollArea>
              <SimpleGrid cols={3}>
                <div>
                  <Button
                    onClick={() => setOpened(true)}
                    variant="blue"
                    style={{ backgroundColor: "#FF6A00", color: "#FFFFFF" }}
                    leftIcon={<Plus size={14} />}
                  >
                    Add Driver
                  </Button>
                </div>
                <div>
                  {" "}
                  <ExportComponent
                    data={drivers}
                    headers={headerData}
                    reportTitle="Driver Report"
                    fileNamePrefix="drivers_report"
                  />
                </div>
                <div className={classes.searchContainer}>
                  <TextInput
                    placeholder="Search"
                    mb="md"
                    icon={<Search size={14} />}
                    value={search}
                    onChange={(event) => setSearch(event.currentTarget.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSearchChange();
                      }
                    }}
                    className={classes.searchInput}
                    rightSection={
                      search && (
                        <UnstyledButton
                          onClick={() => {
                            setSearch("");
                            fetchData(size);
                          }}
                          style={{ padding: 5 }}
                        >
                          <X size={16} color="red" />
                        </UnstyledButton>
                      )
                    }
                  />
                  <button
                    className={classes.searchButton}
                    onClick={handleSearchChange}
                  >
                    <Search size={16} />
                  </button>
                </div>
              </SimpleGrid>
              <Table
                highlightOnHover
                horizontalSpacing="md"
                verticalSpacing="xs"
                sx={{ minWidth: 700 }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#F1F1F1" }}>
                    <Th sortable={false}>
                      <span className={classes.thh}>#</span>
                    </Th>
                    <Th sortable={false} onSort={() => handleSort("name")}>
                      <span className={classes.thh}> Name </span>
                    </Th>
                    <Th sortable={false} onSort={() => handleSort("email")}>
                      <span className={classes.thh}> Email</span>
                    </Th>
                    <Th sortable={false} onSort={() => handleSort("phone")}>
                      <span className={classes.thh}> Phone</span>
                    </Th>
                    <Th sortable={false}>
                      {" "}
                      <span className={classes.thh}>Region</span>
                    </Th>
                    <Th sortable={false} onSort={() => handleSort("email")}>
                      <span className={classes.thh}> City</span>
                    </Th>
                    <Th sortable={false}>
                      <span className={classes.thh}>Vehicle Type</span>
                    </Th>
                    <Th sortable={false}>
                      <span className={classes.thh}>Balance</span>
                    </Th>
                    <Th sortable={false}>
                      {" "}
                      <span className={classes.thh}>Actions</span>
                    </Th>
                  </tr>
                </thead>
                <tbody>
                  {rows?.length > 0 ? (
                    rows
                  ) : (
                    <tr>
                      <td colSpan={9}>
                        <Text weight={500} align="center">
                          Nothing found
                        </Text>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "6px 4px",
                  borderTop: "1px solid #e9ecef",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {/* Left: Showing X–Y of Z */}
                <Text size="sm" style={{ color: "#FF6A00" }}>
                  {`Total Records: ${formatNumber(totalRecords)}`}
                </Text>

                {/* Right: Rows select + navigation */}
                <Group spacing={6} noWrap>
                  <Text size="sm" color="dimmed">
                    Rows
                  </Text>
                  <Select
                    value={size}
                    onChange={handlePageSizeChange}
                    data={PAGE_SIZE_OPTIONS}
                    style={{ width: 72 }}
                    size="xs"
                  />
                  <ActionIcon
                    size="sm"
                    variant="default"
                    onClick={() => handleChange(1)}
                    disabled={activePage <= 1}
                    title="First page"
                    style={{ fontWeight: 700 }}
                  >
                    «
                  </ActionIcon>
                  <ActionIcon
                    size="sm"
                    variant="default"
                    onClick={() => handleChange(activePage - 1)}
                    disabled={activePage <= 1}
                    title="Previous page"
                  >
                    ‹
                  </ActionIcon>
                  <Text size="sm" style={{ minWidth: 40, textAlign: "center" }}>
                    {activePage} / {totalPages}
                  </Text>
                  <ActionIcon
                    size="sm"
                    variant="default"
                    onClick={() => handleChange(activePage + 1)}
                    disabled={activePage >= totalPages}
                    title="Next page"
                  >
                    ›
                  </ActionIcon>
                  <ActionIcon
                    size="sm"
                    variant="default"
                    onClick={() => handleChange(totalPages)}
                    disabled={activePage >= totalPages}
                    title="Last page"
                    style={{ fontWeight: 700 }}
                  >
                    »
                  </ActionIcon>
                </Group>
              </div>
            </ScrollArea>
            <Modal
              opened={openedDelete}
              onClose={() => setOpenedDelete(false)}
              title="Warning"
              centered
            >
              <p>Are you sure do you want todelete this Driver?</p>
              <Group position="right">
                <Button onClick={() => deleteDriver()} color="red">
                  Delete
                </Button>
              </Group>
            </Modal>
          </Card>
        </div>
      </Tabs.Panel>
    </Tabs>
  );
};

export default Drivers;
